import { Button } from '@/common/ui/button'
import { Popover, PopoverContent, PopoverTrigger } from '@/common/ui/popover'
import { CalendarIcon } from '@radix-ui/react-icons'
import * as React from 'react'
import { useDate } from '@/common/hooks/useDate'
import { format } from 'date-fns'

interface MonthPickerProps {
	placeholder?: string
}

const months = [
	'มกราคม',
	'กุมภาพันธ์',
	'มีนาคม',
	'เมษายน',
	'พฤษภาคม',
	'มิถุนายน',
	'กรกฎาคม',
	'สิงหาคม',
	'กันยายน',
	'ตุลาคม',
	'พฤศจิกายน',
	'ธันวาคม',
]

export function MonthPicker({ placeholder = 'เลือกเดือน' }: MonthPickerProps) {
	const { date, setDate } = useDate()
	const [open, setOpen] = React.useState(false)
	const [selectedMonth, setSelectedMonth] = React.useState<Date | undefined>(
		date ? new Date(date + 'T00:00:00') : undefined,
	)
	const [selectedYear, setSelectedYear] = React.useState(
		selectedMonth?.getFullYear() || new Date().getFullYear(),
	)

	const handleMonthSelect = (monthIndex: number) => {
		const newDate = new Date(selectedYear, monthIndex, 1)
		setSelectedMonth(newDate)
		const formattedDate = format(newDate, 'yyyy-MM-dd')
		setDate(formattedDate)
		setOpen(false)
	}

	const handleYearChange = (increment: number) => {
		setSelectedYear((prev) => prev + increment)
	}

	React.useEffect(() => {
		if (date) {
			const newDate = new Date(date + 'T00:00:00')
			setSelectedMonth(newDate)
			setSelectedYear(newDate.getFullYear())
		}
	}, [date])

	return (
		<div className="flex items-center space-x-2">
			<Popover open={open} onOpenChange={setOpen}>
				<PopoverTrigger asChild>
					<Button>
						<CalendarIcon className="mr-2" />
						<span>
							{selectedMonth
								? `${months[selectedMonth.getMonth()]} ${selectedMonth.getFullYear()}`
								: placeholder}
						</span>
					</Button>
				</PopoverTrigger>
				<PopoverContent className="w-[300px] p-4">
					<div className="mb-4 flex items-center justify-between">
						<Button
							variant="outline"
							size="sm"
							onClick={() => handleYearChange(-1)}
						>
							←
						</Button>
						<span className="font-semibold">{selectedYear}</span>
						<Button
							variant="outline"
							size="sm"
							onClick={() => handleYearChange(1)}
						>
							→
						</Button>
					</div>
					<div className="grid grid-cols-3 gap-2">
						{months.map((month, index) => (
							<Button
								key={month}
								variant="outline"
								className={`text-sm ${
									selectedMonth?.getMonth() === index &&
									selectedMonth?.getFullYear() === selectedYear
										? 'bg-primary text-primary-foreground'
										: ''
								}`}
								onClick={() => handleMonthSelect(index)}
							>
								{month}
							</Button>
						))}
					</div>
				</PopoverContent>
			</Popover>
		</div>
	)
}
